import { useEffect, useState } from 'react';

import { routes } from '../../../constants';
import UserService from '../../../services/user.service';
import useRouter from '../../../utils/useRouter';

interface UseLibraryIpValidationProps {
	urlLibrary: string | undefined;
}

const useLibraryIpValidation = ({ urlLibrary }: UseLibraryIpValidationProps) => {
	const { router } = useRouter();
	const [hasValidLibraryIp, setHasValidLibraryIp] = useState(false);
	const [isLibraryReady, setIsLibraryReady] = useState(false);

	useEffect(() => {
		if (urlLibrary) {
			setIsLibraryReady(false);
			UserService.getLibraryIpRange(urlLibrary).then(({ isIpAllowedForLibrary }) => {
				if (!isIpAllowedForLibrary) {
					setHasValidLibraryIp(false);
					setIsLibraryReady(true);
					router.replace(`/${routes.notFound.root}`);
				} else {
					setHasValidLibraryIp(true);
					setIsLibraryReady(true);
				}
			});
		} else {
			setIsLibraryReady(true);
			setHasValidLibraryIp(false);
		}
	}, [urlLibrary, router]);

	return { hasValidLibraryIp, isLibraryReady };
};

export default useLibraryIpValidation;
